import React from 'react'

import {
  CubeOutline,
  Dashboard,
  Upload2,
  WalletOutline,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Seller tools: publishing, models and sales. Dashboard is only shown on the legacy
// (pre-newRoyaltyUi) layout.
function SellerSection({ locale = 'en', newRoyaltyUi = false }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <Section>
      {!newRoyaltyUi && (
        <MenuItem title="Dashboard" url="/profile" svgComponent={Dashboard} dataName="My Dashboard" />
      )}
      <MenuItem
        title={t('navigation.user_menu.seller.publishing')}
        url="/profile/upload/model"
        svgComponent={Upload2}
        dataName="Upload 3D Model"
      />
      <MenuItem
        title={t('navigation.user_menu.seller.models')}
        url="/profile/models"
        svgComponent={CubeOutline}
        dataName="My 3D Models"
      />
      <MenuItem
        title={t('navigation.user_menu.seller.sales')}
        url="/profile/sales"
        svgComponent={WalletOutline}
        dataName="Sales"
      />
    </Section>
  )
}

SellerSection.propTypes = {
  locale: string,
  newRoyaltyUi: bool,
}

export default SellerSection
